import React from 'react';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';
import './filter.css';
import './react-select.css';
import FilterButton from './filter-button/filter-button.js';
import FilterConstants from '../../constants/filter.js';
import MediaQuery from 'react-responsive';
import Select from 'react-select';

class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterClass: 'collapsed',
      genderOption: null,
      sizeOption: null
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    if(this.state.filterClass === 'collapsed') {
      this.setState({filterClass: 'expanding'});
      setTimeout(() => {
        this.setState({filterClass: 'expanded'});
      }, 501);
    } else if(this.state.filterClass === 'expanded') {
      this.setState({filterClass: 'collapsing'});
      setTimeout(() => {
        this.setState({filterClass: 'collapsed'});
      });
    }
  }

  render() {
    const gameTypeNames = this.props.gameTypes;
    const genderTypeNames = FilterConstants.allGenders;
    const sizeNames = FilterConstants.allSizes;
    const patternNames = this.props.patterns;
    const gameTypeFilter = this.props.gameTypeFilter;
    const patternFilter = this.props.patternFilter;
    const genderTypeFilter = this.props.genderTypeFilter;
    const sizeFilter = this.props.sizeFilter;
    const selectGameType = this.props.setGameFilter;

    const selectPattern = this.props.setPatternFilter;
    const selectGenderType = (genderOption) => {
      this.setState({genderOption: genderOption});
      if(genderOption !== null) {
        this.props.setGenderTypeFilter(genderOption.value);
      } else {
        this.props.setGenderTypeFilter(null);
      }
      
    };
    const selectSizeType = (sizeOption) => {
      this.setState({sizeOption: sizeOption});
      if(sizeOption != null) {
        this.props.setSizeFilter(sizeOption.value);
      } else {
        this.props.setSizeFilter(null);
      }
    };
    
    var appliedFilterButtons = null;
    if(patternFilter || genderTypeFilter || sizeFilter) {
      const createFilterButton = (key, title, icon, iconText) => {
        return (
          <FilterButton
            key={key}
            title={title}
            icon={icon}
            iconText={iconText}
            select={this.toggleCollapse} />
        );
      };

      appliedFilterButtons = [];
      if(gameTypeFilter) {
        appliedFilterButtons.push(
          createFilterButton(
            appliedFilterButtons.length,
            gameTypeFilter,
            FilterConstants.gameIcons[gameTypeFilter]
          )
        );
      }
      if(patternFilter) {
        appliedFilterButtons.push(
          createFilterButton(
            appliedFilterButtons.length,
            FilterConstants.patternDisplayNames[patternFilter],
            FilterConstants.patternIcons[patternFilter]
          )
        );
      }
      if(genderTypeFilter) {
        appliedFilterButtons.push(
          createFilterButton(
            appliedFilterButtons.length,
            genderTypeFilter,
            null,
            genderTypeFilter[0]
          )
        );
      }
      if(sizeFilter) {
        appliedFilterButtons.push(
          createFilterButton(
            appliedFilterButtons.length,
            sizeFilter,
            null,
            FilterConstants.sizeDisplayNames[sizeFilter]
          )
        );
      }
    }

    const gameTypeButtons = FilterConstants.allGame.map((gameType, index) => {
      const disabled = gameTypeNames.indexOf(gameType) === -1;
      const selected = gameTypeFilter === gameType;
      const notSelected = (gameTypeFilter && gameTypeFilter !== gameType && gameTypeNames.indexOf(gameType) !== -1);
      return (
        <FilterButton 
          key={index}
          title={gameType}
          icon={FilterConstants.gameIcons[gameType]}
          disabled={disabled}
          selected={selected}
          notSelected={notSelected}
          select={() => selectGameType(gameType)} />
      );
    });

    var genderTypes = genderTypeNames.map((genderType) => {
      return {
        value: genderType,
        label: genderType
      };
    });
    
    var sizes = sizeNames.map((size) => {
      return {
        value: size,
        label: size
      };
    });

    const patternButtons = FilterConstants.allPatterns.map((pattern, index) => {
      const disabled = patternNames.indexOf(pattern) === -1;
      const selected = patternFilter === pattern;
      const notSelected = (patternFilter && patternFilter !== pattern && patternNames.indexOf(pattern) !== -1);
      return (
        <FilterButton 
          key={index}
          title={FilterConstants.patternDisplayNames[pattern]}
          icon={FilterConstants.patternIcons[pattern]}
          disabled={disabled} 
          selected={selected}
          notSelected={notSelected}
          select={() => selectPattern(pattern)} />
      );
    });

    return (
      <div>
        <MediaQuery query="(min-width: 993px)">
          <div id="filter" className="large">
            <div className="filter-large-title">FILTER PRODUCTS BY:</div>
            <div className="filter-section-title">GAME TYPE</div>
            <div data-filter='game' className="filter-button-container">
              {gameTypeButtons}
            </div>
            <div className="filter-divider"></div>
            <div>
              <div className="filter-section-title">PATTERN</div>
              <div data-filter='pattern' className="filter-button-container">
                {patternButtons}
              </div>
            </div>

            <div className="filter-divider"></div>
            <div className="filter-select-container">
              <Select
                name="gender-filter"
                options={genderTypes}
                searchable={false}
                value={this.state.genderOption}
                onChange={selectGenderType}
                clearable={true}
                placeholder="Gender"
                className="filter-select"
              />
              <div className="filter-divider-vertical"></div>
              <Select
                name="size-filter"
                options={sizes}
                value={this.state.sizeOption}
                searchable={false}
                onChange={selectSizeType}
                placeholder="Size"
                className="filter-select"
              />
              
            </div>
            <div className="filter-divider"></div>
          </div>
        </MediaQuery>
        <MediaQuery query="(max-width: 993px)">
          <div id="filter" className={this.state.filterClass}>
            <div>
              <div className="filter-section-title">{this.state.filterClass === 'collapsed' ? (appliedFilterButtons) ? 'ACTIVE FILTERS' : 'FILTER RESULTS BY GAME TYPE' : 'GAME TYPE'}</div>
              <div data-filter={(this.state.filterClass === 'collapsed' && appliedFilterButtons) ? 'applied' : 'game'} className="filter-button-container">
                {(this.state.filterClass === 'collapsed' && appliedFilterButtons) ? appliedFilterButtons : gameTypeButtons}
              </div>
              <div className="filter-divider"></div>
              <div>
                <div className="filter-section-title">PATTERN</div>
                <div data-filter='pattern' className="filter-button-container">
                  {patternButtons}
                </div>
              </div>

              <div className="filter-divider"></div>
              <div className="filter-select-container">
                <Select
                  name="gender-filter"
                  options={genderTypes}
                  searchable={false}
                  value={this.state.genderOption}
                  onChange={selectGenderType}
                  clearable={true}
                  placeholder="Gender"
                  className="filter-select"
                />
                <div className="filter-divider-vertical"></div>
                <Select
                  name="size-filter"
                  options={sizes}
                  value={this.state.sizeOption}
                  searchable={false}
                  onChange={selectSizeType}
                  placeholder="Size"
                  className="filter-select"
                />
                
              </div>
              <div className="filter-divider"></div>
              <span className="filter-toggle" onClick={this.toggleCollapse}>{this.state.filterClass === 'collapsed' ? 'SEE MORE FILTERS' : 'CLOSE FILTERS'}</span>
            </div>
          </div>
        </MediaQuery>
      </div>
    );
  }
}
Filter.propTypes = {
  gameTypes: PropTypes.array,
  patterns: PropTypes.array,
  gameTypeFilter: PropTypes.string,
  patternFilter: PropTypes.string,
  genderTypeFilter: PropTypes.string,
  sizeFilter: PropTypes.string,
  setGameFilter: PropTypes.func.isRequired,
  setPatternFilter: PropTypes.func.isRequired,
  setGenderTypeFilter: PropTypes.func.isRequired,
  setSizeFilter: PropTypes.func.isRequired,
};

export default Filter;


// WEBPACK FOOTER //
// ./src/components/filter/filter.js